import { combineReducers } from "redux";

export const types = {
  SET_INTELLIGENT_FILTER_MODULE_VISIBLE:
    "SCHOOL_FILTER/SET_INTELLIGENT_FILTER_MODULE_VISIBLE",
  SET_INTELLIGENT_ALL_MAJOR_VISIBLE:
    "SCHOOL_FILTER/SET_INTELLIGENT_ALL_MAJOR_VISIBLE",
  SET_INTELLIGENT_MAJOR_VISIBLE: "SCHOOL_FILTER/SET_INTELLIGENT_MAJOR_VISIBLE",
  SET_INTELLIGENT_INLINE_MAJOR_VISIBLE:
    "SCHOOL_FILTER/SET_INTELLIGENT_INLINE_MAJOR_VISIBLE",
  SET_INTELLIGENT_SCHOOL_DETAIL_VISIBLE: "SCHOOL_FILTER/SCHOOL_DETAIL_VISIBLE",
  SET_INTELLIGENT_A_HASH_ID: "SCHOOL_FILTER/SET_INTELLIGENT_A_HASH_ID",
  SET_INTELLIGENT_ADVANCE_MODAL_VISIBLE:
    "SCHOOL_FILTER/SET_INTELLIGENT_ADVANCE_MODAL_VISIBLE",
  SET_INTELLIGENT_ADVANCE_MAJOR_MODAL_VISIBLE:
    "SCHOOL_FILTER/SET_INTELLIGENT_ADVANCE_MAJOR_MODAL_VISIBLE",

  SET_INTELLIGENT_HIGH_SCORE: "SCHOOL_FILTER/SET_INTELLIGENT_HIGH_SCORE",
  SET_INTELLIGENT_ROW_SCORE: "SCHOOL_FILTER/SET_INTELLIGENT_ROW_SCORE",
  SET_INTELLIGENT_MAX_RANK: "SCHOOL_FILTER/SET_INTELLIGENT_MAX_RANK",
  SET_INTELLIGENT_MIN_RANK: "SCHOOL_FILTER/SET_INTELLIGENT_MIN_RANK",
  SET_INTELLIGENT_SCHOOL_NAME: "SCHOOL_FILTER/SET_INTELLIGENT_SCHOOL_NAME",
  SET_INTELLIGENT_MAJOR_NAME: "SCHOOL_FILTER/SET_INTELLIGENT_MAJOR_NAME",
  SET_INTELLIGENT_SUBJECT_FILTER_ID:
    "SCHOOL_FILTER/SET_INTELLIGENT_SUBJECT_FILTER_ID",
  SET_INTELLIGENT_LIMIT_FILTER_ID:
    "SCHOOL_FILTER/SET_INTELLIGENT_LIMIT_FILTER_ID",
  SET_INTELLIGENT_LEVEL_FILTER_ID:
    "SCHOOL_FILTER/SET_INTELLIGENT_LEVEL_FILTER_ID",
  SET_INTELLIGENT_TAG_FILTER_ID: "SCHOOL_FILTER/SET_INTELLIGENT_TAG_FILTER_ID",
  SET_INTELLIGENT_PROPERTY_FILTER_ID:
    "SCHOOL_FILTER/SET_INTELLIGENT_PROPERTY_FILTER_ID",
  SET_INTELLIGENT_PROVINCE_FILTER_ID:
    "SCHOOL_FILTER/SET_INTELLIGENT_PROVINCE_FILTER_ID",
  SET_INTELLIGENT_YEAR: "SCHOOL_FILTER/SET_INTELLIGENT_YEAR",
  SET_INTELLIGENT_PAGE_NUM: "SCHOOL_FILTER/SET_INTELLIGENT_PAGE_NUM",
  SET_INTELLIGENT_PAGE_SIZE: "SCHOOL_FILTER/SET_INTELLIGENT_PAGE_SIZE",

  SET_INTELLIGENT_SUBJECT_MARK_ARRAY:
    "SCHOOL_FILTER/SET_INTELLIGENT_SUBJECT_MARK_ARRAY",
  SET_INTELLIGENT_LIMIT_MARK_ARRAY:
    "SCHOOL_FILTER/SET_INTELLIGENT_LIMIT_MARK_ARRAY",
  SET_INTELLIGENT_LEVEL_MARK_ARRAY:
    "SCHOOL_FILTER/SET_INTELLIGENT_LEVEL_MARK_ARRAY",
  SET_INTELLIGENT_TAG_MARK_ARRAY:
    "SCHOOL_FILTER/SET_INTELLIGENT_TAG_MARK_ARRAY",
  SET_INTELLIGENT_PROPERTY_MARK_ARRAY:
    "SCHOOL_FILTER/SET_INTELLIGENT_PROPERTY_MARK_ARRAY",
  SET_INTELLIGENT_PROVINCE_MARK_ARRAY:
    "SCHOOL_FILTER/SET_INTELLIGENT_PROVINCE_MARK_ARRAY",
  SET_INTELLIGENT_INFO_VISIBLE: "SCHOOL_FILTER/SET_INTELLIGENT_INFO_VISIBLE",
};

const initialState = {
  uiState: {
    filterModuleVisible: false,
    allMajorVisible: false,
    majorVisible: false,
    inlineMajorVisible: false,
    schoolDetailVisible: false,
    advanceModalVisible: false,
    advanceMajorModalVisible: false,
    aHashId: "8DFBj",
    infoVisible: false,
    info: "<p>智能大数据为80个志愿+提前批（右上角）的录取数据。</p><p>出分前的模拟以及出分后的志愿填报，请使用 <a style='text-decoration: none;color: blue;' href='/tocollege/condition'>志愿智能助手。<a></p>",
  },
  schoolFilter: {
    highScore: "",
    rowScore: "",
    maxRank: "",
    minRank: "",
    schoolName: "",
    majorName: "",
    subjectFilterId: [],
    limitFilterId: [],
    levelFilterId: [],
    tagFilterId: [],
    propertyFilterId: [],
    provinceFilterId: [],
    year: 2026,
    pageNum: 1,
    pageSize: 10,
  },
  markArray: {
    subjectMarkArray: [0, 0, 0, 0, 0, 0, 0],
    limitMarkArray: [0, 0, 0, 0],
    levelMarkArray: [0, 0],
    tagMarkArray: [0, 0, 0],
    propertyMarkArray: [0, 0, 0, 0],
    provinceMarkArray: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
  },
};

export const actions = {
  //设置信息的显示和关闭
  setInfoVisible: (infoVisible) => {
    return {
      type: types.SET_INTELLIGENT_INFO_VISIBLE,
      infoVisible,
    };
  },
  //设置智能大数据过滤数据弹出框显示和关闭
  setFilterModuleVisible: (filterModuleVisible) => {
    return {
      type: types.SET_INTELLIGENT_FILTER_MODULE_VISIBLE,
      filterModuleVisible,
    };
  },
  //设置院校所有专业显示的弹出框的显示和关闭
  setAllMajorVisible: (allMajorVisible) => {
    return {
      type: types.SET_INTELLIGENT_ALL_MAJOR_VISIBLE,
      allMajorVisible,
    };
  },
  //设置内嵌的院校专业显示的弹出框的显示和关闭
  setInlineMajorVisible: (inlineMajorVisible) => {
    return {
      type: types.SET_INTELLIGENT_INLINE_MAJOR_VISIBLE,
      inlineMajorVisible,
    };
  },
  //设置院校专业显示的弹出框的显示和关闭
  setMajorVisible: (majorVisible) => {
    return {
      type: types.SET_INTELLIGENT_MAJOR_VISIBLE,
      majorVisible,
    };
  },
  //设置院校详情显示的弹出框的显示和关闭
  setSchoolDetailVisible: (schoolDetailVisible) => {
    return {
      type: types.SET_INTELLIGENT_SCHOOL_DETAIL_VISIBLE,
      schoolDetailVisible,
    };
  },
  //设置院校详情显示院校要使用到的a_Hash_Id
  setAHashId: (aHashId) => {
    return {
      type: types.SET_INTELLIGENT_A_HASH_ID,
      aHashId,
    };
  },

  //设置智能大数据提前批弹出框的显示和关闭
  setAdvanceModalVisible: (advanceModalVisible) => {
    return {
      type: types.SET_INTELLIGENT_ADVANCE_MODAL_VISIBLE,
      advanceModalVisible,
    };
  },

  //设置智能大数据提前批专业列表弹出框的显示和关闭
  setAdvanceMajorModalVisible: (advanceMajorModalVisible) => {
    return {
      type: types.SET_INTELLIGENT_ADVANCE_MAJOR_MODAL_VISIBLE,
      advanceMajorModalVisible,
    };
  },

  /********************************分隔符 */
  //设置高分
  setHighScore: (highScore) => {
    return {
      type: types.SET_INTELLIGENT_HIGH_SCORE,
      highScore,
    };
  },
  //设置低分
  setRowScore: (rowScore) => {
    return {
      type: types.SET_INTELLIGENT_ROW_SCORE,
      rowScore,
    };
  },
  //设置最大位次
  setMaxRank: (maxRank) => {
    return {
      type: types.SET_INTELLIGENT_MAX_RANK,
      maxRank,
    };
  },
  //设置最低位次
  setMinRank: (minRank) => {
    return {
      type: types.SET_INTELLIGENT_MIN_RANK,
      minRank,
    };
  },
  //设置学校名称
  setSchoolName: (schoolName) => {
    return {
      type: types.SET_INTELLIGENT_SCHOOL_NAME,
      schoolName,
    };
  },
  //设置专业名称
  setMajorName: (majorName) => {
    return {
      type: types.SET_INTELLIGENT_MAJOR_NAME,
      majorName,
    };
  },
  //设置选科
  setSubjectFilterId: (subjectFilterId) => {
    return {
      type: types.SET_INTELLIGENT_SUBJECT_FILTER_ID,
      subjectFilterId,
    };
  },
  //设置选科限制过滤数据
  setLimitFilterId: (limitFilterId) => {
    return {
      type: types.SET_INTELLIGENT_LIMIT_FILTER_ID,
      limitFilterId,
    };
  },
  //设置专业级别过滤数据
  setLevelFilterId: (levelFilterId) => {
    return {
      type: types.SET_INTELLIGENT_LEVEL_FILTER_ID,
      levelFilterId,
    };
  },
  //设置高校标签过滤数据
  setTagFilterId: (tagFilterId) => {
    return {
      type: types.SET_INTELLIGENT_TAG_FILTER_ID,
      tagFilterId,
    };
  },
  //设置办学性质过滤数据
  setPropertyFilterId: (propertyFilterId) => {
    return {
      type: types.SET_INTELLIGENT_PROPERTY_FILTER_ID,
      propertyFilterId,
    };
  },
  //设置地区省份过滤数据
  setProvinceFilterId: (provinceFilterId) => {
    return {
      type: types.SET_INTELLIGENT_PROVINCE_FILTER_ID,
      provinceFilterId,
    };
  },
  //设置年份
  setYear: (year) => {
    return {
      type: types.SET_INTELLIGENT_YEAR,
      year,
    };
  },
  //设置页码
  setPageNum: (pageNum) => {
    return {
      type: types.SET_INTELLIGENT_PAGE_NUM,
      pageNum,
    };
  },
  //设置分页的页面跨度
  setPageSize: (paseSize) => {
    return {
      type: types.SET_INTELLIGENT_PAGE_SIZE,
      paseSize,
    };
  },
  /**************************************/
  //设置选科选中标识
  setSubjectMarkArray: (subjectMarkArray) => {
    return {
      type: types.SET_INTELLIGENT_SUBJECT_MARK_ARRAY,
      subjectMarkArray,
    };
  },
  //设置选科限制选中标识
  setLimitMarkArray: (limitMarkArray) => {
    return {
      type: types.SET_INTELLIGENT_LIMIT_MARK_ARRAY,
      limitMarkArray,
    };
  },
  //设置高校层次选中标识
  setLevelMarkArray: (levelMarkArray) => {
    return {
      type: types.SET_INTELLIGENT_LEVEL_MARK_ARRAY,
      levelMarkArray,
    };
  },
  //设置高校标签选中标识
  setTagMarkArray: (tagMarkArray) => {
    return {
      type: types.SET_INTELLIGENT_TAG_MARK_ARRAY,
      tagMarkArray,
    };
  },
  //设置办学性质选中标识
  setPropertyMarkArray: (propertyMarkArray) => {
    return {
      type: types.SET_INTELLIGENT_PROPERTY_MARK_ARRAY,
      propertyMarkArray,
    };
  },
  //设置地区选中标识
  setProvinceMarkArray: (provinceMarkArray) => {
    return {
      type: types.SET_INTELLIGENT_PROVINCE_MARK_ARRAY,
      provinceMarkArray,
    };
  },
};

//智能大数据ui样式的数据
const uiStateData = (state = initialState.uiState, action) => {
  switch (action.type) {
    case types.SET_INTELLIGENT_INFO_VISIBLE:
      return {
        ...state,
        infoVisible: action.infoVisible,
      };
    case types.SET_INTELLIGENT_FILTER_MODULE_VISIBLE:
      return { ...state, filterModuleVisible: action.filterModuleVisible };
    case types.SET_INTELLIGENT_ALL_MAJOR_VISIBLE:
      return { ...state, allMajorVisible: action.allMajorVisible };
    case types.SET_INTELLIGENT_MAJOR_VISIBLE:
      return { ...state, majorVisible: action.majorVisible };
    case types.SET_INTELLIGENT_INLINE_MAJOR_VISIBLE:
      return { ...state, inlineMajorVisible: action.inlineMajorVisible };
    case types.SET_INTELLIGENT_SCHOOL_DETAIL_VISIBLE:
      return { ...state, schoolDetailVisible: action.schoolDetailVisible };
    case types.SET_INTELLIGENT_A_HASH_ID:
      return { ...state, aHashId: action.aHashId };
    case types.SET_INTELLIGENT_ADVANCE_MODAL_VISIBLE:
      return { ...state, advanceModalVisible: action.advanceModalVisible };
    case types.SET_INTELLIGENT_ADVANCE_MAJOR_MODAL_VISIBLE:
      return {
        ...state,
        advanceMajorModalVisible: action.advanceMajorModalVisible,
      };
    default:
      return { ...state };
  }
};

//智能大数据筛选条件的数据
const schoolFilterData = (state = initialState.schoolFilter, action) => {
  switch (action.type) {
    case types.SET_INTELLIGENT_HIGH_SCORE:
      return { ...state, highScore: action.highScore };
    case types.SET_INTELLIGENT_ROW_SCORE:
      return { ...state, rowScore: action.rowScore };
    case types.SET_INTELLIGENT_MAX_RANK:
      return { ...state, maxRank: action.maxRank };
    case types.SET_INTELLIGENT_MIN_RANK:
      return { ...state, minRank: action.minRank };
    case types.SET_INTELLIGENT_SCHOOL_NAME:
      return { ...state, schoolName: action.schoolName };
    case types.SET_INTELLIGENT_MAJOR_NAME:
      return { ...state, majorName: action.majorName };
    case types.SET_INTELLIGENT_SUBJECT_FILTER_ID:
      return { ...state, subjectFilterId: action.subjectFilterId };
    case types.SET_INTELLIGENT_LIMIT_FILTER_ID:
      return { ...state, limitFilterId: action.limitFilterId };
    case types.SET_INTELLIGENT_LEVEL_FILTER_ID:
      return { ...state, levelFilterId: action.levelFilterId };
    case types.SET_INTELLIGENT_TAG_FILTER_ID:
      return { ...state, tagFilterId: action.tagFilterId };
    case types.SET_INTELLIGENT_PROPERTY_FILTER_ID:
      return { ...state, propertyFilterId: action.propertyFilterId };
    case types.SET_INTELLIGENT_PROVINCE_FILTER_ID:
      return { ...state, provinceFilterId: action.provinceFilterId };
    case types.SET_INTELLIGENT_YEAR:
      return { ...state, year: action.year };
    case types.SET_INTELLIGENT_PAGE_NUM:
      return { ...state, pageNum: action.pageNum };
    case types.SET_INTELLIGENT_PAGE_SIZE:
      return { ...state, pageSize: action.pageSize };
    default:
      return { ...state };
  }
};

//院校筛选中标识的数据
const schoolMarkArrayData = (state = initialState.markArray, action) => {
  switch (action.type) {
    case types.SET_INTELLIGENT_SUBJECT_MARK_ARRAY:
      return { ...state, subjectMarkArray: action.subjectMarkArray };
    case types.SET_MAJOR_LIMIT_MARK_ARRAY:
      return { ...state, limitMarkArray: action.limitMarkArray };
    case types.SET_MAJOR_LEVEL_MARK_ARRAY:
      return { ...state, levelMarkArray: action.levelMarkArray };
    case types.SET_MAJOR_TAG_MARK_ARRAY:
      return { ...state, tagMarkArray: action.tagMarkArray };
    case types.SET_MAJOR_PROPERTY_MARK_ARRAY:
      return { ...state, propertyMarkArray: action.propertyMarkArray };
    case types.SET_MAJOR_PROVINCE_MARK_ARRAY:
      return { ...state, provinceMarkArray: action.provinceMarkArray };
    default:
      return { ...state };
  }
};

const reducer = combineReducers({
  uiStateData,
  schoolFilterData,
  schoolMarkArrayData,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/intelligentbigdata.js